import React, { useState } from 'react';
import ContactStrip from 'components/contact-strip';
import Title from 'components/title';
import styles from '../styles/PolicyDetailsContainer.module.scss';
import PolicyDetailsStatus from './PolicyDetailsStatus';
import MobileRenewPopup from 'components/modals/MobileRenewPopup';
import { INSURANCE_TYPES_NAMES } from 'constants/insurance-types-names';

const ALT_TITLES = {
  [INSURANCE_TYPES_NAMES.MBI]: 'Mechanical Breakdown insurance',
};

const PolicyDetailsTitle = ({
  className,
  img,
  policy,
  policyProvider,
  allowMarketScan,
}) => {
  const [showMobileRenew, setShowMobileRenew] = useState(false);
  const handleShowMobileRenewPopup = () => {
    setShowMobileRenew((prev) => !prev);
  };

  const title =
    ALT_TITLES[policy?.policyType] || `${policy?.policyType} insurance`;

  return (
    <div className={styles.header}>
      <MobileRenewPopup
        show={showMobileRenew}
        setShow={setShowMobileRenew}
        allowMarketScan={allowMarketScan}
      />
      <Title
        id="PolicyDetails_Title"
        img={img}
        titleClassName={classnames(styles.title, className)}
        title={policy.employerId ? `${title} | ${policy.employerName}` : title}
      />
      <PolicyDetailsStatus
        policy={policy}
        onClick={handleShowMobileRenewPopup}
      />
      {policyProvider && <ContactStrip {...policyProvider} />}
    </div>
  );
};

export default PolicyDetailsTitle;
